//
// State Machine

StateMachine = function (statePhase) {
  var _statePhase = statePhase;
  var _states = [];
  var _activeStateIndex = -1;
  var _previousStateIndex = -1;
  var _nextState = -1;
  var _stateDataStore = {};

  this.update = function () {
    if (_nextState !== -1) {
      if (_activeStateIndex !== -1) {
        _statePhase._exitState();
        _states[_activeStateIndex].callback(_stateDataStore[_states[_activeStateIndex].name], _stateDataStore);
        _previousStateIndex = _activeStateIndex;
      }

      _activeStateIndex = _nextState;
      _statePhase.reset();
      _statePhase._registerPhases();
      _states[_activeStateIndex].callback(_stateDataStore[_states[_activeStateIndex].name], _stateDataStore);
      _statePhase._endRegisterPhases();
      _nextState = -1;
    }

    if (_activeStateIndex !== -1) {
      _statePhase._currentActiveIndex = 0;
      _states[_activeStateIndex].callback(_stateDataStore[_states[_activeStateIndex].name], _stateDataStore);
    }
  };

  this.addState = function (name, callback) {
    _states.push({
      name: name,
      callback: callback,
    });
    _stateDataStore[name] = {};
  };

  this.replaceState = function (name, callback) {
    var found = _states.find(function (element) {
      return element.name === name;
    });
    if (found) {
      found.callback = callback;
    } else this.addState(name, callback);
  };

  this.switchState = function (name) {
    var next = _states.find(function (element) {
      return element.name === name;
    });

    if (next === undefined) {
      console.log('stateMachine could not find state ' + name);
    } else {
      _nextState = _states.indexOf(next);
    }
  };

  Object.defineProperty(this, 'StateNames', {
    get: function () {
      var names = [];
      for (var i = 0; i < _states.length; ++i) {
        names.push(_states[i].name);
      }

      return names;
    },
  });
  Object.defineProperty(this, 'ActiveStateName', {
    get: function () {
      return _activeStateIndex === -1 ? '' : _states[_activeStateIndex].name;
    },
  });
  Object.defineProperty(this, 'PreviousStateName', {
    get: function () {
      return _previousStateIndex === -1 ? '' : _states[_previousStateIndex].name;
    },
  });
};

StateMachine.Create = function (controller) {
  controller.phase = new StatePhase();
  controller.stateMachine = new StateMachine(controller.phase);
};
